import formattedScheduleFunc from '@/helpers/shops/formattedSchedule'
import formattedPhoneFunc from '@/helpers/shops/formattedPhone'
import formattedStoresServicesFunc from '@/helpers/shops/formattedStoresServices'

export default (data, placement = null) => {
  const list = []

  data.forEach(el => {
    const {
      address_name: addressName,
      geo,
      phone,
      schedule,
      services,
      google_link: googleLink,
      image,
      subway,
      city_name: city,
      city_id: cityId,
      stores_services: storesServices,
      type
    } = el

    const formattedSchedule = formattedScheduleFunc(schedule)
    const formattedPhone = formattedPhoneFunc(phone)
    const formattedStoresServices = formattedStoresServicesFunc(storesServices)

    let pt = {
      city: city ?? '',
      cityId: cityId ?? '',
      description_ru: addressName ?? '',
      title: addressName ?? '',
      googleLink: googleLink ?? '',
      image: image ?? '',
      placement: placement ?? '',
      scheduleObj: formattedSchedule ?? {},
      phone: formattedPhone ?? '',
      services: services ?? [],
      storesServices: formattedStoresServices ?? [],
      subway: subway ?? [],
      near_subway: subway?.length > 0 ?? false,
      opened: formattedSchedule.opened ?? false,
      type: type ?? ''
    }

    if (geo !== undefined) {
      pt.latitude = +geo.latitude
      pt.longitude = +geo.longitude
    }

    if (placement) {
      pt.placement = placement
    }

    list.push(pt)
  })

  return list
}
